import { keyframes, styled } from '@stitches/configed';
import { animate } from 'framer-motion';
import { SVGProps } from 'react';

const rotate = keyframes({
  to: { transform: 'rotate(360deg)' },
});

const Wrap = styled('div', {
  animation: `${rotate} 1500ms linear infinite`,
});

export const LoadingOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Wrap>
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5001 3.16602C15.7637 3.16602 15.1667 3.76297 15.1667 4.49935V8.49935C15.1667 9.23573 15.7637 9.83268 16.5001 9.83268C17.2365 9.83268 17.8334 9.23573 17.8334 8.49935V4.49935C17.8334 3.76297 17.2365 3.16602 16.5001 3.16602Z"
          fill="black"
        />
        <path
          d="M16.5001 23.166C15.7637 23.166 15.1667 23.763 15.1667 24.4993V28.4993C15.1667 29.2357 15.7637 29.8327 16.5001 29.8327C17.2365 29.8327 17.8334 29.2357 17.8334 28.4993V24.4993C17.8334 23.763 17.2365 23.166 16.5001 23.166Z"
          fill="black"
        />
        <path
          d="M28.5001 15.166C29.2365 15.166 29.8334 15.763 29.8334 16.4993C29.8334 17.2357 29.2365 17.8327 28.5001 17.8327H24.5001C23.7637 17.8327 23.1667 17.2357 23.1667 16.4993C23.1667 15.763 23.7637 15.166 24.5001 15.166H28.5001Z"
          fill="black"
        />
        <path
          d="M9.83342 16.4993C9.83342 15.763 9.23646 15.166 8.50008 15.166H4.50008C3.7637 15.166 3.16675 15.763 3.16675 16.4993C3.16675 17.2357 3.7637 17.8327 4.50008 17.8327H8.50008C9.23646 17.8327 9.83342 17.2357 9.83342 16.4993Z"
          fill="black"
        />
        <path
          d="M24.0426 7.07139C24.5633 6.55069 25.4075 6.55069 25.9282 7.07139C26.4489 7.59209 26.4489 8.43631 25.9282 8.95701L23.0998 11.7854C22.5791 12.3061 21.7349 12.3061 21.2142 11.7854C20.6935 11.2647 20.6935 10.4205 21.2142 9.89982L24.0426 7.07139Z"
          fill="black"
        />
        <path
          d="M11.786 21.2133C11.2653 20.6926 10.4211 20.6926 9.90037 21.2133L7.07194 24.0417C6.55125 24.5624 6.55125 25.4067 7.07194 25.9274C7.59264 26.4481 8.43686 26.4481 8.95756 25.9274L11.786 23.0989C12.3067 22.5782 12.3067 21.734 11.786 21.2133Z"
          fill="black"
        />
        <path
          d="M25.9282 24.0419C26.4489 24.5626 26.4489 25.4068 25.9282 25.9275C25.4075 26.4482 24.5633 26.4482 24.0426 25.9275L21.2142 23.0991C20.6935 22.5784 20.6935 21.7342 21.2142 21.2135C21.7349 20.6928 22.5791 20.6928 23.0998 21.2135L25.9282 24.0419Z"
          fill="black"
        />
        <path
          d="M11.7861 11.7853C12.3068 11.2646 12.3068 10.4203 11.7861 9.89964L8.95769 7.07121C8.43699 6.55051 7.59277 6.55051 7.07207 7.07121C6.55137 7.59191 6.55137 8.43613 7.07207 8.95683L9.9005 11.7853C10.4212 12.306 11.2654 12.306 11.7861 11.7853Z"
          fill="black"
        />
      </svg>
    </Wrap>
  );
};
